import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=34aa8d40&scoped=true&"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa8d40",
  null
  
)

export default component.exports